import type { AdditionalTrackingData } from '@hotjar/dashboard-quantz';
import type { ContextOfUse } from '@hotjar/global-filters';
import { Button } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import type { StepMarker } from './Steps';
import { Steps } from './Steps';

interface AddStepSectionProps {
  addOneChain: () => void;
  trackClick: (eventName: string, additionalTrackingData: AdditionalTrackingData) => void;
  kind: 'step' | 'filter';
  index: number;
  isFunnelStep?: boolean;
  contextOfUse: ContextOfUse;
}

export const AddStepSection = ({
  addOneChain,
  trackClick,
  kind,
  index,
  isFunnelStep,
  contextOfUse,
}: AddStepSectionProps): JSX.Element => {
  const { t } = useTranslation('global-filters');
  const stepMarker: StepMarker =
    kind === 'filter'
      ? { kind: 'dot' }
      : {
          kind: 'text',
          textValue: `${index + 1}`,
          textColor: 'text_disabled',
        };

  return (
    <Steps.AddNewStep stepMarker={stepMarker} isFunnelStep={isFunnelStep}>
      <Button
        kind="ghost"
        icon="plus"
        aria-label={kind === 'filter' ? t('compareWith') : t('addStep')}
        onClick={() => {
          if (kind === 'filter') {
            trackClick('compare_with_opened_global_filters_menu', {
              ui_position: contextOfUse.page,
              state_event_was_triggered_on: contextOfUse.page,
              element_name: 'compare_with_opened_global_filters_menu',
            });
          } else {
            trackClick('add_step_menu', {
              ui_position: contextOfUse.page,
              state_event_was_triggered_on: contextOfUse.page,
              element_name: 'add_step_menu',
            });
          }
          addOneChain();
        }}
      >
        {kind === 'filter' ? t('compareWith') : t('addStep')}
      </Button>
    </Steps.AddNewStep>
  );
};
